import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
    standalone: false
})
export class ErrorComponent implements OnInit {

  message: string;

  // Constructor
  constructor(private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.message = this.activatedRoute.snapshot.paramMap.get('message');
  }

  // Sets the message to display
  setMessage(message: string) {
    this.message = message;
  }
}
